export enum EFlashcardState {
  NOT_ANSWERED = 'NOT_ANSWERED',
  I_KNOW_IT = 'I_KNOW_IT',
  NEED_TO_REVIEW = 'NEED_TO_REVIEW',
  I_DONT_KNOW_IT = 'I_DONT_KNOW_IT'
}

export const FLASHCARD_STATE_VALUES = Object.values(EFlashcardState);